"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOVE_OUT_CONFIRM_ERROR = exports.MOVE_OUT_POST_ERROR = exports.MOVE_OUT_VIEW_ERROR = void 0;
exports.MOVE_OUT_VIEW_ERROR = 'move-out-view-error';
exports.MOVE_OUT_POST_ERROR = 'move-out-post-error';
exports.MOVE_OUT_CONFIRM_ERROR = 'move-out-confirm-error';
